// src/components/settings/IntegrationsPanel.jsx
//
// Read-only health of what .env configures, plus test buttons that send a
// real email / push to the superadmin who presses them. Keys are never shown.

import React, { useEffect, useState } from 'react';
import { apiFetchJSON } from '../../api/apiClient';

const STATE = {
  ok: { cls: 'ok', label: 'Working' },
  warn: { cls: 'warn', label: 'Check' },
  bad: { cls: 'bad', label: 'Missing' },
  off: { cls: 'off', label: 'Off' },
};

export default function IntegrationsPanel() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [testing, setTesting] = useState(null);
  const [result, setResult] = useState(null);

  useEffect(() => {
    apiFetchJSON('/api/v2/admin/settings/integrations').then(setData).catch((e) => setError(e.message));
  }, []);

  const runTest = async (kind) => {
    setTesting(kind);
    setResult(null);
    try {
      const r = await apiFetchJSON(`/api/v2/admin/settings/integrations/test-${kind}`, { method: 'POST' });
      setResult({ kind, ok: true, text: r.message });
    } catch (e) {
      setResult({ kind, ok: false, text: e.message });
    } finally {
      setTesting(null);
    }
  };

  if (error) return <div className="ft-toolbar-error" role="alert">{error}</div>;
  if (!data) return <div className="st-loading">Checking integrations…</div>;

  return (
    <div className="st-integrations">
      <p className="st-panel-note"><i className="fas fa-lock" aria-hidden="true"></i> {data.note}</p>
      {result && (
        <div className={`st-test-result ${result.ok ? 'is-ok' : 'is-bad'}`} role="status">{result.text}</div>
      )}
      {data.groups.map((g) => (
        <section key={g.title} className="st-group">
          <h3 className="st-group-title">{g.title}</h3>
          <ul className="st-int-list">
            {g.items.map((it) => {
              const st = STATE[it.state] || STATE.off;
              return (
                <li key={it.id} className="st-int">
                  <span className={`st-int-dot is-${st.cls}`} aria-hidden="true" />
                  <span className="st-int-text">
                    <span className="st-int-label">{it.label}</span>
                    <span className="st-int-detail">{it.detail}</span>
                  </span>
                  <span className="st-int-side">
                    <span className={`st-int-state is-${st.cls}`}>{st.label}</span>
                    {it.test && (
                      <button type="button" className="bl-btn-ghost is-accent st-int-test" disabled={!!testing}
                              onClick={() => runTest(it.test)}>
                        {testing === it.test ? 'Sending…' : it.test === 'email' ? 'Send test email' : 'Send test push'}
                      </button>
                    )}
                  </span>
                </li>
              );
            })}
          </ul>
        </section>
      ))}
    </div>
  );
}
